import React from 'react'
import styled from 'styled-components'
import { Field, Form, Formik } from 'formik'
import Button from '../Buttons/Button'
import Input from '../Input'
import { TextSubtitle, TextTitle } from '../Styles/TextStyles'
import loginIllustration from '../../assets/illustrations/login.svg'
import InlineLink from '../InlineLink'
import Card from '../Cards/Card'


const LoginPage = ({ handleView, mailSignin }) => (
  <Card alt="login page" imageSrc={loginIllustration}>
    <Formik
      initialValues={{ email: '', password: '' }}
      onSubmit={(data, { setSubmitting, resetForm }) => {
        setSubmitting(true)
        mailSignin(data)
        setSubmitting(false)
        resetForm()
      }}
    >
      {({ values, isSubmitting }) => (
        <Form>
          <LeftContainer>
            <TextContainer>
              <Title>Log in</Title>
              <Subtitle>It&apos;s great to have you back.</Subtitle>
            </TextContainer>
            <InputContainer>
              <Field name="email" label="Email Address" type="email" as={Input} />
              <Field name="password" label="Password" type="password" as={Input} />
            </InputContainer>
            <ButtonContainer>
              <Button text="Log in" disabled={isSubmitting} type="submit" />
            </ButtonContainer>
            <ExtraContainer>
              <InlineLink
                text="Forgot your password?"
                textLink="Reset password"
                handleView={() => handleView('reset')}
              />
            </ExtraContainer>
          </LeftContainer>
        </Form>
      )}
    </Formik>
  </Card>
)

const LeftContainer = styled.div`
  align-content: center;
  display: grid;
  gap: 1.5em;
  grid-template-rows: repeat(3, min-content);
  height: 100%;
  width: 320px;
`

const TextContainer = styled.div`
  display: grid;
  gap: 0.2em;
`

const Title = styled(TextTitle)``

const Subtitle = styled(TextSubtitle)``

const InputContainer = styled.div`
  display: grid;
  gap: 1em;
`

const ButtonContainer = styled.div``

const ExtraContainer = styled.div`
  display: grid;
  gap: 0.5em;
  grid-template-rows: repeat(2, min-content);
`

export default LoginPage



// WEBPACK FOOTER //
// ./src/components/login/components/Pages/LoginPage.js